import Colors from 'builder/styles/colors'
import { CategoryIds } from '../../CategoryTabs'
import * as Widgets from '../widgets'
import { Service } from '..'
import { WidgetProps } from '../widgets/widget.types'

export type Theme = {
  primary: string
  base: string
  soft: string
  muted: string
  text: string
}

const DocumentsTheme = {
  primary: Colors.Blue50,
  base: Colors.Blue40,
  soft: Colors.Blue10,
  muted: Colors.Blue20,
  text: Colors.Blue80,
  badge: Colors.Blue15,
}

const JobsTheme = {
  primary: Colors.Indigo50,
  base: Colors.Indigo40,
  soft: Colors.Indigo10,
  muted: Colors.Indigo20,
  text: Colors.Indigo80,
  badge: Colors.Indigo15,
}

const CareerTheme = {
  primary: Colors.Green50,
  base: Colors.Green40,
  soft: Colors.Green10,
  muted: Colors.Green20,
  text: Colors.Green80,
  badge: Colors.Green15,
}

export const DS: Record<CategoryIds, Array<Service>> = {
  resumes: [
    {
      id: 'resume_crafting',
      title: 'Resume crafting',
      defaultActive: true,
      progress: 70,
      icon: 'ResumeCrafting',
      component: 'ResumeCrafting',
      theme: DocumentsTheme,
    },
    {
      id: 'resume_tailoring',
      title: 'Resume tailoring',
      defaultActive: false,
      progress: 30,
      icon: 'ResumeTailoring',
      component: 'ResumeTailoring',
      theme: DocumentsTheme,
    },
    {
      id: 'resume_distribution',
      title: 'Resume distribution',
      defaultActive: false,
      progress: 0,
      icon: 'ResumeDistribution',
      component: 'ResumeDistribution',
      theme: DocumentsTheme,
    },
    {
      id: 'cover_letter_crafting',
      title: 'Cover letter crafting',
      defaultActive: false,
      progress: 0,
      icon: 'CoverLetterCrafting',
      component: 'CoverLetterCrafting',
      theme: DocumentsTheme,
    },
  ],
  jobs: [
    {
      id: 'jobs_crafting',
      title: 'Jobs applied for',
      defaultActive: true,
      progress: 22,
      icon: 'JobsApplied',
      component: 'JobsApplied',
      theme: JobsTheme,
    },
    {
      id: 'resume_distribution',
      title: 'Resume distribution',
      defaultActive: false,
      progress: 66,
      icon: 'ResumeDistribution',
      component: 'ResumeDistribution',
      theme: DocumentsTheme,
    },
    {
      id: 'job_search_strategy',
      title: 'Job search strategy',
      defaultActive: false,
      progress: 7,
      icon: 'JobSearchStrategy',
      component: 'JobSearchStrategy',
      theme: CareerTheme,
    },
  ],
  interviews: [
    {
      id: 'interviews_practiced',
      title: 'Interviews practiced',
      defaultActive: true,
      progress: 22,
      icon: 'InterviewsPracticed',
      component: 'InterviewsPracticed',
      theme: CareerTheme,
    },
    {
      id: 'questions_practiced',
      title: 'Questions practiced',
      defaultActive: false,
      progress: 22,
      icon: 'QuestionsPracticed',
      component: 'QuestionsPracticed',
      theme: CareerTheme,
    },
    {
      id: 'interview_strategy',
      title: 'Interview strategy',
      defaultActive: false,
      progress: 22,
      icon: 'InterviewStrategy',
      component: 'InterviewStrategy',
      theme: CareerTheme,
    },
    {
      id: 'interviews_passed',
      title: 'Interviews passed',
      defaultActive: false,
      progress: 22,
      icon: 'InterviewsPassed',
      component: 'InterviewsPassed',
      theme: CareerTheme,
    },
  ],
  careers: [
    {
      id: 'first_90_days_plan',
      title: 'First 90 days plan',
      defaultActive: true,
      progress: 22,
      icon: 'First90DaysPlan',
      component: 'First90DaysPlan',
      theme: CareerTheme,
    },
    {
      id: 'get_promotion',
      title: 'Get a promotion',
      defaultActive: false,
      progress: 22,
      icon: 'GetPromotion',
      component: 'GetPromotion',
      theme: CareerTheme,
    },
    {
      id: 'change_careers',
      title: 'Change careers',
      defaultActive: false,
      progress: 22,
      icon: 'ChangeCareers',
      component: 'ChangeCareers',
      theme: CareerTheme,
    },
  ],
}

export const componentsMap: Record<string, React.FC<WidgetProps>> = {
  ResumeCrafting: props => <Widgets.ResumeCrafting {...props} />,
  ResumeTailoring: props => <Widgets.ResumeTailoring {...props} />,
  ResumeDistribution: props => <Widgets.ResumeDistribution {...props} />,
  CoverLetterCrafting: props => <Widgets.CoverLetterCrafting {...props} />,
  JobsApplied: props => <Widgets.JobApplied {...props} />,
  JobSearchStrategy: props => <Widgets.JobSearchStartegy {...props} />,
  InterviewsPracticed: props => <Widgets.InterviewsPracticed {...props} />,
  QuestionsPracticed: props => <Widgets.QuestionsPracticed {...props} />,
  InterviewStrategy: props => <Widgets.InterviewStrategy {...props} />,
  InterviewsPassed: props => <Widgets.InterviewsPassed {...props} />,
  First90DaysPlan: props => <Widgets.First90DaysPlan {...props} />,
  GetPromotion: props => <Widgets.GetPromotion {...props} />,
  ChangeCareers: props => <Widgets.ChangeCareers {...props} />,
  _: () => <div>Default Component</div>,
}
